function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
}
function headerHeight() {
  if (document.body.contains(document.querySelector('[data-site-header]'))) {
    const headerHeight =
      document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
    return headerHeight;
  } else {
    return;
  }
}

function halfPageOffset() {
  if (document.body.contains(document.querySelector('.page-width'))) {
    const container = document.querySelector('.page-width');
    const offset = container.offsetLeft;
    return offset;
  }
}

function announcementHeight() {
  if (
    document.body.contains(document.querySelector('[data-announcement-bar]'))
  ) {
    const announcementHeight = document.querySelector(
      '[data-announcement-bar]'
    ).offsetHeight;
    //console.log(announcementHeight);
    if (announcementHeight == 0) {
      return 36;
    } else {
      return announcementHeight;
    }
  } else {
    return 0;
  }
}

document.documentElement.style.setProperty(
  '--window-height',
  windowHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--header-height',
  headerHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--announcement-height',
  announcementHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--half-page-offset',
  halfPageOffset() + 'px'
);

window.addEventListener(
  'resize',
  debounce(function () {
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--half-page-offset',
      halfPageOffset() + 'px'
    );
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementHeight() + 'px'
    );
  }, 50)
);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

window.addEventListener(
  'scroll',
  debounce(function () {
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--half-page-offset',
      halfPageOffset() + 'px'
    );
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementHeight() + 'px'
    );
  }, 550)
);

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
}

/************ Smooth Scroll  ****************/

/*
document
  .querySelectorAll(
    'a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target], [href*="#:~:text="])'
  )
  .forEach((anchor) => {
    //console.log(anchor, 'ANCHOR');
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('scroll to ', e);
      const offset = (headerHeight() + announcementHeight()) * -2;
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = anchor.hash;
        target = target.length
          ? target
          : document.querySelector(`[name="${this.hash.slice(1)}"]`);

        if (target.length) {
          const element = document.getElementById(target.replace('#', ''));
          console.log('element', element);
          window.scrollTo({
            top: getOffsetTop(element) + offset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    });
  });

function getOffsetTop(element) {
  return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
} */

// VARIANT SELECTING

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const formatterWholeNum = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

class bdVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.variantChange);
  }

  variantChange(event) {
    const formId = this.dataset.form;
    const container = document.querySelector(`[data-product-info="${formId}"]`);
    const variantData = JSON.parse(
      this.querySelector('[data-variant-data]').textContent
    );

    // console.log(variantData, 'VARIANT DATA');
    const newVariantId = event.target.value;
    const selectId = event.target.dataset.id;

    document.querySelectorAll(`[data-id="${selectId}"]`).forEach((select) => {
      select.value = newVariantId;
    });

    const selectedVariantArray = variantData.filter(
      (obj) => obj.id == newVariantId
    );
    // console.log(selectedVariantArray, 'SVA');
    const selectedVariant = selectedVariantArray[0];

    const imageContainer = container.querySelector(`.image`);
    this.updatePrices(container, selectedVariant);
    this.updateImages(imageContainer, selectedVariant);
  }

  updateImages(imageContainer, selectedVariant) {
    console.log(selectedVariant, 'SELECTED VARIANT');
    const imageIndex = selectedVariant.featured_media.position;
    const flkty = Flickity.data(imageContainer.querySelector('.bd-slider'));
    console.log(flkty, 'SLIDER');
    flkty.select(imageIndex - 1);
  }

  updatePrices(container, selectedVariant) {
    console.log(container, 'PRODUCT CONTAINER');
    const priceContainer = container.querySelector('[data-bd-price]');
    const originalPrice = formatterWholeNum.format(
      selectedVariant.price * 0.01
    );
    priceContainer.querySelector('[data-current-price]').innerHTML =
      originalPrice;
  }
}
customElements.define('bd-variants', bdVariantSelects);

class bdSecondaryForm extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.clickEvents);
  }

  clickEvents(event) {
    event.preventDefault();
    console.log(event, 'CLICKED');
    if (
      event.target.hasAttribute('data-secondary-button') ||
      event.target.parentElement.hasAttribute('data-secondary-button')
    ) {
      console.log('ADD TO CART PRODUCT');
      const formId = this.dataset.form;
      const container = document.querySelector(
        `[data-product-info="${formId}"]`
      );
      container.querySelector('[type="submit"]').click();
    }
  }
}

customElements.define('secondary-form', bdSecondaryForm);

// console.clear();
console.log('metabundle');
class metaBundles extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.changeEvents);
  }

  changeEvents(event) {
    event.preventDefault();

    const targetOption = event.target.dataset.targetOption;
    const option = event.target.options[event.target.selectedIndex];
    const optionName = option.dataset.variantName;

    const form = this.closest('form');

    const targetSelect = form.querySelector(
      `fieldset[data-option="${targetOption}"]`
    );

    //targetSelect.querySelector(`[data-value-name="${optionName}"]`).checked = true;

    targetSelect
      .querySelector(`[data-value-name="${optionName}"] + label`)
      .click();
  }
}

customElements.define('meta-bundles', metaBundles);
